<template>
  <div class="team-record-list">
    <div
      v-for="(item, idx) in teamRecordData"
      :key="idx"
      class="team-record-card"
    >
      <emptyModule :title="getTeamRecordTitle(item)">
        <div v-if="source == ''" class="more-record-item">
          <div class="more-record-item-content">
          <div class="bar">
            <span> </span>
            <span> </span>
          </div>
          <div
            class="order 111"
            v-if="shouldShowOrder(item) && getNationalGameRankText(item)[2] === 0"
          >
            <h3 v-if="getGameTypeByName(item.name) !== 0">
              {{ getGameTypeDisplayName(item) }}
            </h3>
            <div class="text">
              <div
                class="title-tag"
                v-if="shouldShowWarZoneTag(item)"
              >
                <span v-if="getGameTypeByName(item.name) === 3">{{ item.group_name }}</span>
                <span v-else-if="getGameTypeByName(item.name) != 3">{{ item.ware_zone }}</span>
              </div>
              <p v-if="shouldShowRank(item) &&  getRankDisplayText(item)">
                <span>第</span>
                <label v-if="(getGameTypeByName(item.name) != 3)">{{ getRankDisplayText(item) }}</label>
                <label v-else-if="getGameTypeByName(item.name) === 3 && item.name === '全国大赛-小组赛'">{{ item.ware_zone_rank }}</label>
                <span>名</span>
              </p>
              <p v-else-if="shouldShowRank(item) &&  !getRankDisplayText(item)">暂无排名</p>
              <!-- <div v-if="getGameTypeByName(item.name) === 3 && item.name !== '全国大赛-小组赛'">
                <span>{{ getNationalGameRankText(item)[0] }}</span>
              </div>
              <div v-if="getGameTypeByName(item.name) === 3 && item.name === '全国大赛-小组赛' && new Date() > new Date(item.sched_end_date)">
                <span>{{ getNationalGameRankText(item)[0] }}</span>
              </div> -->
              <div v-if="((getGameTypeByName(item.name) === 3) && getNationalGameRankText(item)[0] !== '' && new Date() > new Date(item.sched_end_date))">
                <span>{{ getNationalGameRankText(item)[0] }}</span>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="game-type-title" :class="{'no-margin-bottom': getNationalGameRankText(item)[2] !== 0}">
              <img src="../../../assets/images/squirrelCup/2023/summer/yh.png" />
              <p>{{ getGameTypeDisplayName(item) }}</p>
              <img src="../../../assets/images/squirrelCup/2023/summer/yh2.png" />
            </div>
          </div>
          <template v-if="shouldShowSpecificPromoteImg(item)">
            <div class="promote-img">
              <img
                src="../../../assets/images/squirrelCup/2023/summer/promote.png"
              />
            </div>
          </template>
          </div>
        </div>
        <div v-else class="more-record-item">
          <div class="bar">
            <span> </span>
            <span> </span>
          </div>
          <div class="more-record-item-content">
            <div class="game-type-title" :class="{'no-margin-bottom': getNationalGameRankText(item)[2] !== 0}">
              <img src="../../../assets/images/squirrelCup/2023/summer/yh.png" />
              <p>{{ getGameTypeDisplayName(item) }}</p>
              <img src="../../../assets/images/squirrelCup/2023/summer/yh2.png" />
            </div>
            <div class="other-rank-wrapper" v-if="getNationalGameRankText(item)[2] == 0 && getNationalGameRankText(item)[3] !== -1">
              <div
                class="title-tag"
                v-if="shouldShowWarZoneTag(item)"
              >
                <span v-if="getGameTypeByName(item.name) === 3">{{ item.group_name }}</span>
                <span v-else-if="getGameTypeByName(item.name) != 3">{{ item.ware_zone }}</span>
              </div>
              <p v-if="shouldShowRank(item) && getRankDisplayText(item)">
                <span>第</span>
                <label v-if="(getGameTypeByName(item.name) != 3)">{{ getRankDisplayText(item) }}</label>
                <label v-else-if="getGameTypeByName(item.name) === 3 && item.name === '全国大赛-小组赛'">{{ item.ware_zone_rank }}</label>
                <span>名</span>
              </p>
              <p v-else-if="shouldShowRank(item) && !getRankDisplayText(item)">暂无排名</p>
            </div>
            <div v-if="((getGameTypeByName(item.name) === 3) && getNationalGameRankText(item)[1] !== '')" class="rank-text-wrapper">
              <span>{{ getNationalGameRankText(item)[1] }}</span>
            </div>
          </div>
        </div>
        <rankingImg
          v-if="getNationalGameRankText(item)[2] !== 0"
          :honorType="getNationalGameRankText(item)[2]"
          :areaHonorName="getNationalGameRankText(item)[3] ? getNationalGameRankText(item)[3] : ''"
        ></rankingImg>
        <ul class="rank-data">
          <li v-if="shouldShowFirstRankDataLi(item)">
            <p class="data-num">
              {{ getScoreDisplayValue(item) | formatNumberFilter }}
            </p>
            <p class="describe">{{ getScoreDescription(item) }}</p>
          </li>
          <li :class="getSecondLiClass(item)">
            <p class="data-num">
              {{ getPkCountDisplayValue(item) | formatNumberFilter }}
            </p>
            <p class="describe">{{ getPkCountDescription(item) }}</p>
          </li>
        </ul>
        <shareBtn
          v-if="shouldShowShareBtn(item) && getRankDisplayText(item)"
          :id="'zhanduizhanji' + idx"
          :title="'查看海报'"
          @shareClick="handleShareClick(item)"
        />
        <div v-if="shouldShowPromoteImg(item)" class="promote-img">
          <img src="../../../assets/images/winterGame/promoted_icon.png" />
        </div>
      </emptyModule>
    </div>
    <van-popup
      style="width: 100%"
      v-model="isShowBattleReportPosterPopUpDialog"
    >
      <battalionPoster
        :posterUrl="battleReportPoster.posterUrl"
        :isShow="battleReportPoster.isShow"
        @OnCancelPoster="handleCancelBattleReportPoster"
      >
        <div id="battleReportPosterContainer">
          <battle-report
            :teamInfo="teamInfo"
            :posterData="battleReportPosterData"
            v-if="battleReportPoster.isPoster == 1"
          >
          </battle-report>
        </div>
      </battalionPoster>
    </van-popup>
    <van-popup style="width: 100%" v-model="isShowPopUpDialog">
      <battalionPoster
        :posterUrl="teamHonorPoster.posterUrl"
        :isShow="teamHonorPoster.isShow"
        @OnCancelPoster="handleCancelTeamHonorPoster"
      >
        <div id="teamHonorPosterContainer">
          <teamHonorPost
            :teamInfo="teamInfo"
            :posterData="teamHonorPosterData"
            v-if="teamHonorPoster.isPoster == 1"
          ></teamHonorPost>
        </div>
      </battalionPoster>
    </van-popup>
  </div>
</template>

<script>
import emptyModule from "./emptyModule.vue";
import rankingImg from "./rankingImg.vue";
import shareBtn from "./shareBtn.vue";
import { Toast } from "vant";
import html2canvas from "html2canvas";
import battalionPoster from "@components/SquirrelCupII/battalion-poster.vue";
import BattleReport from "@views/WinterGame/components/poster/battleReport.vue";
import teamHonorPost from "@views/WinterGame/components/poster/teamHonorPost.vue";

import {
  debounce,
  formatDateStr,
  getGameType,
  getHonorDesc,
  getTeamHonorPosterData,
} from "@/util/util";

export default {
  name: "TeamRecordList",
  data() {
    return {
      isShowBattleReportPosterPopUpDialog: false,
      battleReportPoster: {
        posterUrl: "",
        isShow: false,
        isPoster: 0,
      },
      teamHonorPoster: {
        isShow: false,
        isPoster: -1,
        posterUrl: "",
      },
      battleReportPosterData: {},
      teamHonorPosterData: {},
      teamInfo: {
        teamName: "",
        servicePointName: "",
      },
      isShowPopUpDialog: false,
    };
  },
  components: {
    emptyModule,
    rankingImg,
    shareBtn,
    battalionPoster,
    BattleReport,
    teamHonorPost,
  },
  props: {
    teamRecordData: {
      type: Array,
      default: () => [],
    },
    source: {
      type: String,
      default: '',
    }
  },
  mounted() {
    let teamInfo = localStorage.getItem("teamInfo");
    this.teamInfo = JSON.parse(teamInfo);
  },
  methods: {
    getTeamRecordTitle(item) {
      if (!item) return "战队战绩";
      if (item.ware_zone && item.ware_zone_rank) {
        return `${item.ware_zone}战区第${item.ware_zone_rank}名`;
      } else if (item.rank) {
        return `第${item.rank}名`;
      } else {
        return "战队战绩";
      }
    },
    getGameTypeByName(name) {
      if (!name) return 0;

      if (name.indexOf("全网大乱斗") !== -1) {
        return 1;
      } else if (name.indexOf("精英争霸赛") !== -1) {
        return 2;
      } else if (name.indexOf("全国大赛") !== -1) {
        return 3;
      } else if (name.indexOf("竞技场争霸赛") !== -1) {
        return 7;
      } else if (name.indexOf("竞技场大乱斗") !== -1) {
        return 6;
      } else if (name.indexOf("全国64强战队") !== -1) {
        return 4;
      } else if (name.indexOf("全国32强战队") !== -1) {
        return 4;
      } else if (name.indexOf("全国16强战队") !== -1) {
        return 4;
      } else if (name.indexOf("全国8强战队") !== -1) {
        return 4;
      } else if (name.indexOf("全国冠军战队") !== -1) {
        return 4;
      } else if (name.indexOf("全国亚军战队") !== -1) {
        return 4;
      } else if (name.indexOf("全国季军战队") !== -1) {
        return 4;
      } else if (name.indexOf("竞技场冠军战队") !== -1) {
        return 7;
      } else if (name.indexOf("竞技场亚军战队") !== -1) {
        return 7;
      } else if (name.indexOf("竞技场季军战队") !== -1) {
        return 7;
      } else if (name.indexOf("战队联赛") !== -1) {
        return 8;
      } else if (name.indexOf("热身赛") !== -1) {
        return 9;
      } else if (name.indexOf("战区联赛") !== -1) {
        return 10;
      } else {
        return 0;
      }
    },
    getHonorTypeByName(name) {
      if (!name) return 0;

      if (name.indexOf("全国64强战队") !== -1) {
        return 1;
      } else if (name.indexOf("全国32强战队") !== -1) {
        return 2;
      } else if (name.indexOf("全国16强战队") !== -1) {
        return 3;
      } else if (name.indexOf("全国8强战队") !== -1) {
        return 4;
      } else if (name.indexOf("全国冠军战队") !== -1) {
        return 6;
      } else if (name.indexOf("全国亚军战队") !== -1) {
        return 7;
      } else if (name.indexOf("全国季军战队") !== -1) {
        return 8;
      } else if (name.indexOf("竞技场冠军战队") !== -1) {
        return 9;
      } else if (name.indexOf("竞技场亚军战队") !== -1) {
        return 10;
      } else if (name.indexOf("竞技场季军战队") !== -1) {
        return 11;
      } else if (/战区冠军$/.test(name)) {
        return 5;
      } else {
        return 0;
      }
    },
    // 获取游戏类型显示名称
    getGameTypeDisplayName(item) {
      const gameType = this.getGameTypeByName(item.name);
      
      switch (gameType) {
        case 1:
          return '全网大乱斗';
        case 2:
          return '精英争霸赛';
        case 3:
          // return item.name === '全国大赛-小组赛' ? '全国大赛' : '全国大赛';
          if (item.sched_section_name.indexOf('全国大赛') > -1) {
            return item.sched_section_name
          } else {
            return item.name
          }
        case 6:
          return '竞技场大乱斗';
        case 7:
          return '竞技场争霸赛';
        case 8:
          return '战队联赛';
        case 9:
          return '热身赛';
        case 10:
          return '战区联赛';
        default:
          return '';
      }
    },
    // 获取排名显示文本
    getRankDisplayText(item) {
      const gameType = this.getGameTypeByName(item.name);
      
      if (gameType === 3) {
        return this.getNationalGameRankText(item)[0];
      }
      switch (gameType) {
        case 1:
          return item.sched_rank;
        case 2:
          return item.sched_rank;
        case 3:
          return item.ware_zone_rank;
        case 6:
          return item.sched_rank;
        case 7:
          return item.ware_zone_rank;
        case 9:
          return item.ware_zone ? item.ware_zone_rank : item.sched_rank;
        case 10:
          return item.ware_zone_rank;
        default:
          return '';
      }
    },
    // 获取全国大赛排名文本
    getNationalGameRankText(item) {
      const sectionName = item.sched_section_name;
      if (sectionName === '全国大赛-淘汰赛' || sectionName === '全国大赛淘汰赛') {
        return item.advancement === 1 ? ['32强战队', '全国32强战队', 0, -1] : ['64强战队', '全国64强战队', 0, -1];
      } else if (sectionName === '全国大赛-32进16' || sectionName === '全国大赛32进16') {
        return item.advancement === 1 ? ['16强战队', '全国16强战队', 0, -1] : ['32强战队', '全国32强战队', 0, -1];
      } else if (sectionName === '全国大赛-16进8' || sectionName === '全国大赛16进8') {
        return item.advancement === 1 ? ['8强战队', '全国8强战队', 0, -1] : ['16强战队', '全国16强战队', 0, -1];
      } else if (sectionName === '全国大赛-8进4' || sectionName === '全国大赛8进4') {
        return item.advancement === 1 ? ['4强战队', '', 5, `${item.ware_zone}赛区冠军`] : ['8强战队', '', 0, -1];
      } else if (sectionName === '全国大赛-半决赛' || sectionName === '全国大赛半决赛') {
        return ['赛区冠军', '', 5, `${item.ware_zone}赛区冠军`];
      } else if (sectionName === '全国大赛-决赛' || sectionName === '全国大赛决赛') {
        if (item.group_name == '冠军争夺') {
          if (item.advancement === 1) {
            return ['冠军', '', 6];
          } else {
            return ['亚军', '', 7];
          }
        } else if (item.group_name == '季军争夺') {
          if (item.advancement === 1) {
            return ['季军', '', 8];
          } else {
            return ['第4名', '', 12];
          }
        } else {
          return ['', '', 5];
        }
      } else if (item.name === '全国大赛-小组赛' || item.name === '全国大赛小组赛') {
        const currentDate = new Date();
        const schedEndDate = new Date(item.sched_end_date);
        if (currentDate < schedEndDate) { // 进行中
          return [item.ware_zone_rank, '', 0];
        } else {
          if (item.advancement === 1) {
            return ['32强战队', '全国32强战队', 0, -1];
          } else {
            return ['64强战队', '全国64强战队', 0, -1];
          }
        }
      } else if (item.name === '竞技场争霸赛') {
        const currentDate = new Date();
        const schedEndDate = new Date(item.sched_end_date);
        if (currentDate < schedEndDate) {
          return [item.ware_zone_rank, '', 0];
        } else {
          if (item.ware_zone_rank == 1) {
            return ['冠军', '', 9, item.ware_zone];
          } else if (item.ware_zone_rank == 2) {
            return ['亚军', '', 10, item.ware_zone];
          } else if (item.ware_zone_rank == 3) {
            return ['季军', '', 11, item.ware_zone];
          } else {
            return ['', '', 0];
          }
        }
      }
      
      return ['', '', 0];
    },
    // 是否显示战区标签
    shouldShowWarZoneTag(item) {
      const gameType = this.getGameTypeByName(item.name);
      return gameType === 2 || 
             (gameType === 3 && (item.name === '全国大赛-小组赛' || item.name === '全国大赛小组赛') && new Date() < new Date(item.sched_end_date)) ||
             gameType === 8 || gameType === 7 ||
             gameType === 10;
    },
    // 是否显示排名
    shouldShowRank(item) {
      const sched_end_date = item.sched_end_date;
      let currentDate = new Date();
      let schedEndDate = new Date(sched_end_date);
      const gameType = this.getGameTypeByName(item.name);
      return (gameType !== 4 && gameType !== 3) || (gameType === 3 && (item.name === '全国大赛-小组赛' || item.name === '全国大赛小组赛') && currentDate < schedEndDate);
    },
    shouldShowShareBtn(item) {
      const sched_end_date = item.sched_end_date;
      let currentDate = new Date();
      let schedEndDate = new Date(sched_end_date);
      const gameType = this.getGameTypeByName(item.name);
      // return (gameType !== 4 && gameType !== 3) || (gameType === 3 && item.name === '全国大赛-小组赛');
      return gameType !== 4
    },
    // 获取奖杯数显示值
    getScoreDisplayValue(item) {
      const gameType = this.getGameTypeByName(item.name);
      
      if (gameType === 2) {
        return item.sched_score;
      } else if (gameType === 3 && (item.name === '全国大赛-小组赛' || item.name === '全国大赛小组赛')) {
        return item.medal_count || 0;
      }
      
      return item.sched_score;
    },
    // 获取PK局数显示值
    getPkCountDisplayValue(item) {
      const gameType = this.getGameTypeByName(item.name);
      
      if (gameType === 2) {
        return item.sched_pk_count;
      } else if (gameType === 3) {
        return item.sched_score;
      }
      
      return item.sched_pk_count;
    },
    // 获取奖杯数描述
    getScoreDescription(item) {
      const gameType = this.getGameTypeByName(item.name);
      
      if (gameType === 3 && (item.name === '全国大赛-小组赛' || item.name === '全国大赛小组赛')) {
        return '勋章数';
      }
      
      return '奖杯数';
    },
    // 获取PK局数描述
    getPkCountDescription(item) {
      const gameType = this.getGameTypeByName(item.name);
      
      if (gameType === 3) {
        return '奖杯数';
      }
      
      return 'PK局数';
    },
    // 是否显示晋级图片
    shouldShowPromoteImg(item) {
      const gameType = this.getGameTypeByName(item.name);
      return item && item.advancement === 1 && ((gameType == 3 && item.name == '全国大赛-小组赛') || gameType == 1 || gameType == 2 || gameType == 6)
    },
    // 是否显示特定晋级图片（全网大乱斗和精英争霸赛）
    shouldShowSpecificPromoteImg(item) {
      const gameType = this.getGameTypeByName(item.name);
      return (gameType === 1 || gameType === 2) && item && item.advancement === 1;
    },
    // 是否显示order区域
    shouldShowOrder(item) {
      const gameType = this.getGameTypeByName(item.name);
      return gameType !== 4;
    },
    // 是否显示rank-data的第一个li
    shouldShowFirstRankDataLi(item) {
      const gameType = this.getGameTypeByName(item.name);
      return gameType !== 3 || (gameType === 3 && (item.name === '全国大赛-小组赛' || item.name === '全国大赛小组赛'));
    },
    // 获取第二个li的class
    getSecondLiClass(item) {
      const gameType = this.getGameTypeByName(item.name);
      return gameType === 3 && (item.name !== '全国大赛-小组赛' && item.name !== '全国大赛小组赛') ? 'no-medal' : '';
    },
    handleShareClick(mainData) {
      console.log('mainData', mainData.ware_zone_rank, this.getGameTypeByName(mainData.name))
     if ((this.getGameTypeByName(mainData.name) != 3 && this.getGameTypeByName(mainData.name) != 7) 
      || (this.getGameTypeByName(mainData.name) === 3 && (mainData.name === '全国大赛-小组赛' || mainData.name === '全国大赛小组赛') && new Date() < new Date(mainData.sched_end_date))
      || (this.getGameTypeByName(mainData.name) === 7 && mainData.name === '竞技场争霸赛' && new Date() < new Date(mainData.sched_end_date))
      || (this.getGameTypeByName(mainData.name) === 7 && mainData.name === '竞技场争霸赛' && new Date() >= new Date(mainData.sched_end_date) && mainData.ware_zone_rank > 3)
    )
    {
      console.log('mainData', 'zxxxxx-2')
      this.lookZhanjPoster(mainData)
     } else {
      console.log('mainData', 'zxxxxx-1')
      this.lookTeamHonorPoster(mainData);
     }
    },
    lookZhanjPoster(mainData) {
      Toast.loading({ message: "加载中...", forbidClick: true, duration: 0 });
      this.isShowBattleReportPosterPopUpDialog = true;
      this.battleReportPoster.isPoster = 1;
      this.battleReportPosterData = {
        cupNumber: mainData.sched_score,
        warZone: mainData.ware_zone,
        rank: mainData.rank,
        ware_zone_rank: mainData.ware_zone_rank,
        country_rank: mainData.country_rank,
        sched_daily_rank: mainData.sched_daily_rank,
        pkCount: mainData.sched_pk_count,
        name: mainData.name,
        teamStatus: 3,
        group_name: mainData.group_name,
        date: mainData.yyyy_mm_dd,
        sched_date: mainData.sched_date,
        gameType: this.getGameTypeByName(mainData.name),
        sched_rank: mainData.sched_rank,
        advancement: mainData.advancement || 0,
        sched_end_date: mainData.sched_end_date,
      };
      setTimeout(() => {
        const dom = document.querySelector("#battleReportPosterContainer");
        const targetDom = dom.firstChild;
        const config = {
          useCORS: true,
          logging: true,
          width: targetDom.offsetWidth,
          height: targetDom.offsetHeight - 4,
        };
        html2canvas(targetDom, config).then((canvas) => {
          this.battleReportPoster.isShow = true;
          this.battleReportPoster.posterUrl = canvas.toDataURL();
          this.battleReportPoster.isPoster = -1;
          Toast("长按保存图片");
        });
      },1000);
    },
    lookTeamHonorPoster(mainData) {
      Toast.loading({ message: "加载中...", forbidClick: true, duration: 0 });
      this.teamHonorPoster.isPoster = 1;
      this.isShowPopUpDialog = true;
      this.teamHonorPosterData = {
        cupNumber: mainData.score,
        warZone: mainData.ware_zone,
        rank: mainData.rank,
        ware_zone_rank: mainData.ware_zone_rank,
        country_rank: mainData.country_rank,
        sched_daily_rank: mainData.sched_daily_rank,
        pkCount: mainData.pk_count,
        name: mainData.name,
        sched_section_name: mainData.sched_section_name,
        teamStatus: 3,
        group_name: mainData.group_name,
        date: mainData.sched_date,
        gameType: this.getGameTypeByName(mainData.name),
        sched_rank: mainData.sched_rank,
        advancement: mainData.advancement || 0,
        sched_date: mainData.sched_date,
      };
      setTimeout(() => {
        const targetDom = document.querySelector("#teamHonorPosterContainer");
        const config = {
          useCORS: true,
          logging: true,
          width: targetDom.offsetWidth,
          height: targetDom.offsetHeight - 4,
        };
        html2canvas(targetDom, config).then((canvas) => {
          this.teamHonorPoster.isShow = true;
          this.teamHonorPoster.posterUrl = canvas.toDataURL();
          this.teamHonorPoster.isPoster = -1;
          Toast('长按保存图片');;
        });
      }, 1000);
    },
    handleCancelBattleReportPoster(type) {
      this.battleReportPoster.isShow = type;
      this.isShowBattleReportPosterPopUpDialog = false;
      this.$toast.clear(); // 清除当前 Toast
    },
    handleCancelTeamHonorPoster(type) {
      this.teamHonorPoster.isShow = type;
      this.isShowPopUpDialog = false;
      this.$toast.clear(); // 清除当前 Toast
    },
  },
};
</script>

<style lang="less" scoped>
.team-record-list {
  .team-record-card {
    margin-bottom: 16px;

    div.bar {
      position: absolute;
      top: 8px;
      left: 0;
      right: 0;
      display: flex;
      justify-content: space-between;

      span {
        display: inline-block;

        width: 16px;
        height: 14px;
        background: linear-gradient(180deg, #4099f8 0%, #1650b1 100%);

        &:first-child {
          margin-left: -16px;
          border-top-left-radius: 7px;
          border-bottom-left-radius: 7px;
        }

        &:last-child {
          margin-right: -16px;
          border-top-right-radius: 7px;
          border-bottom-right-radius: 7px;
        }
      }
    }

    footer {
      width: 622px;
      margin: 0 auto;
      margin-top: 24px;
      text-align: right;
      position: relative;

      .more {
        width: 242px;
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #58abf6;
        line-height: 40px;
      }
    }

    .rank-data {
      display: flex;
      flex-wrap: wrap;

      li {
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .data-num {
          font-size: 48px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #323232;
          margin: 0 0 8px 0;
          padding: 0;
        }

        .describe {
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #68707d;
          margin: 0 0 32px 0;
          padding: 0;
        }
        &.no-medal {
          width: 100%!important;
        }
      }
    }

    .order {
      width: 70%;
      height: 306px;
      background: url("../../../assets/images/winterGame/orderBg.png") no-repeat;
      background-size: 100%;
      background-position: center;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      h3 {
        position: absolute;
        top: 10px;
        left: calc(50% - 123);
        width: 246px;
        height: 46px;
        background: rgba(88, 171, 246, 0.16);
        border-radius: 24px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #619cf5;
        line-height: 46px;
        text-align: center;
      }

      .text {
        color: #ffffff;
        text-shadow: 0px 0px 16px #ae7000;
        font-size: 48px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        margin-top: 40px;

        label {
          font-size: 58px;
          line-height: 50px;
        }

        .title-tag {
          width: 176px;
          background: #d5862f;
          border-radius: 20px;
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 40px;
          text-align: center;
          // position: absolute;
          // top: -25px;
        }

        p {
          margin: 0;
          position: relative;
          // margin-top: 60px;
        }
      }
      .promote-img {
        position: absolute;
        bottom: 0;
        right: -90px;
        width: 156px;
        height: 156px;

        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
    .other-rank-wrapper {
      width: 100%;
      height: 98px;
      margin-top: 24px;
      margin-bottom: 24px;
      background: #E4F1FD;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 48px;
      color: #323232;
      text-align: center;
      font-style: normal;
    }

    .rank-text-wrapper {
      width: 100%;
      height: 98px;
      margin-top: 24px;
      background: #E4F1FD;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 48px;
        color: #323232;
        text-align: center;
        font-style: normal;
      }
    }

    .promote-img {
      position: absolute;
      top: 120px;
      right: 0px;
      width: 156px;
      height: 156px;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .more-record-item {
      // margin-bottom: 20px;
      .more-record-item-content {
        .game-type-title {
          height: 1em;
          line-height: 1em;
          margin-top: 24px;
          margin-bottom: 24px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #323232;
          > img:first-child {
            display: block;
            width: 32px;
            height: 24px;
            margin-right: 10px;
          }
          > img:last-child {
            display: block;
            width: 32px;
            height: 24px;
            margin-left: 10px;
          }
          &.game-type-title-draw {
            font-size: 1.5rem;
          }
          &.no-margin-bottom {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style> 